import { Component, OnInit, inject } from '@angular/core';
import { FormGroup } from '../../data/form-group';
import { FormGroupService } from '../../services/form-group.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FormService } from '../../services/form.service';
import { OverviewListItem } from '../../data/overview-list-item';
import { environment } from '../../../environments/environment';
import { LoaderComponent } from '@rbb/ng-web-template-lib';

@Component({
  selector: 'app-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.css'],
  imports: [RouterLink, LoaderComponent]
})
export class GroupComponent implements OnInit {
  private formGroupService = inject(FormGroupService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private formService = inject(FormService);

  id: string | undefined;
  formGroup: FormGroup | undefined;
  productiveForms: OverviewListItem[] | undefined;

  constructor() {
    this.id = this.route.snapshot.params['id'];
  }

  ngOnInit(): void {
    this.getFormGroup();
    if (!environment.dataProtectionOfficer) {
      this.getProductiveForms();
    }
  }

  getFormGroup(): void {
    if (this.id) {
      this.formGroupService.getFormGroupForUser(this.id).subscribe({
        next: (data) => {
          this.formGroup = data;
          document.title = document.title.replace(environment.title, environment.title + ' - ' + this.formGroup.name);
        },
        error: () => {
          this.router.navigateByUrl('/list').then();
        }
      });
    }
  }

  getOptions(formGroup: FormGroup): { key: string; value: string }[] {
    return Object.keys(formGroup.options ?? {})
      .sort()
      .map(s => ({
        key: s.replace(s.split('-', 1)[0] + '-', ''),
        value: formGroup.options?.[s] ?? ''
      }));
  }

  getLinks(formGroup: FormGroup): { key: string; value: string }[] {
    return Object.keys(formGroup.links ?? {})
      .sort()
      .map(s => ({
        key: s.replace(s.split('-', 1)[0] + '-', ''),
        value: formGroup.links?.[s] ?? ''
      }));
  }

  isProductive(tag: string, name: string): boolean {
    return !!this.productiveForms?.filter(f => f.tag === tag || f.name === name).length;
  }

  getProductiveForms(): void {
    this.formService.getProductiveVisibleForms().subscribe(next => this.productiveForms = next);
  }
}
